export function BackgroundTextureLines(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      fill="none"
      height="583"
      viewBox="0 0 790 178"
      width="1247"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M-139.547 -271C-43.0684 -250.449 108.193 -208.859 31.2404 -77.5704C-66.6867 89.5039 -305.99 45.7351 -199.707 174.688"
        stroke="currentColor"
      />
      <path
        d="M-84.4036 -212.75C12.0752 -192.199 163.336 -150.609 86.3839 -19.3204C-11.5432 147.754 -250.846 103.985 -144.564 232.938"
        stroke="currentColor"
      />
      <path
        d="M-54.7752 -187.906C41.7036 -167.355 192.965 -125.766 116.012 5.52326C18.0853 172.598 -221.218 128.829 -114.935 257.782"
        stroke="currentColor"
      />
      <path
        d="M-23.6678 -166.95C72.811 -146.399 224.072 -104.809 147.12 26.4798C49.1927 193.554 -190.11 149.785 -83.8278 278.738"
        stroke="currentColor"
      />
      <path
        d="M8.82634 -150.693C105.305 -130.142 256.566 -88.5523 179.614 42.7365C81.6868 209.811 -157.616 166.042 -51.3337 294.995"
        stroke="currentColor"
      />
      <path
        d="M42.4162 -139.709C138.895 -119.158 290.156 -77.5685 213.204 53.7203C115.277 220.795 -124.026 177.026 -17.7438 305.979"
        stroke="currentColor"
      />
      <path
        d="M76.6657 -134.051C173.145 -113.5 324.405 -71.9099 247.453 59.3789C149.526 226.453 -89.777 182.684 16.5057 311.637"
        stroke="currentColor"
      />
      <path
        d="M111.143 -133.155C207.622 -112.604 358.883 -71.0141 281.931 60.2747C184.004 227.349 -55.2994 183.58 50.9832 312.533"
        stroke="currentColor"
      />
      <path
        d="M145.567 -136.032C242.045 -115.481 393.306 -73.8911 316.354 57.3977C218.427 224.472 -20.8761 180.703 85.4066 309.656"
        stroke="currentColor"
      />
      <path
        d="M179.826 -141.568C276.305 -121.017 427.566 -79.427 350.613 51.8618C252.686 218.936 13.3832 175.167 119.666 304.12"
        stroke="currentColor"
      />
      <path
        d="M213.932 -148.739C310.411 -128.188 461.672 -86.5978 384.719 44.691C286.792 211.765 47.4892 167.996 153.772 296.95"
        stroke="currentColor"
      />
      <path
        d="M247.949 -156.701C344.428 -136.15 495.689 -94.5597 418.736 36.7291C320.809 203.803 81.5062 160.035 187.789 288.988"
        stroke="currentColor"
      />
      <path
        d="M281.95 -164.796C378.429 -144.245 529.69 -102.655 452.738 28.6335C354.811 195.708 115.508 151.939 221.79 280.892"
        stroke="currentColor"
      />
      <path
        d="M315.994 -172.53C412.473 -151.979 563.734 -110.389 486.781 20.8996C388.854 187.974 149.551 144.205 255.834 273.158"
        stroke="currentColor"
      />
      <path
        d="M350.117 -179.539C446.596 -158.988 597.857 -117.398 520.904 13.8908C422.977 180.965 183.674 137.196 289.957 266.149"
        stroke="currentColor"
      />
      <path
        d="M384.334 -185.564C480.813 -165.013 632.074 -123.423 555.122 7.86555C457.195 174.94 217.891 131.171 324.174 260.124"
        stroke="currentColor"
      />
      <path
        d="M418.645 -190.431C515.124 -169.88 666.385 -128.29 589.432 2.99897C491.505 170.073 252.202 126.304 358.485 255.258"
        stroke="currentColor"
      />
      <path
        d="M453.246 -194.073C549.725 -173.522 700.986 -131.932 624.033 -0.643362C526.106 166.431 286.803 122.662 393.086 251.615"
        stroke="currentColor"
      />
      <path
        d="M487.673 -196.876C584.151 -176.326 735.412 -134.736 658.46 -3.44683C560.533 163.627 321.23 119.859 427.513 248.812"
        stroke="currentColor"
      />
      <path
        d="M522.124 -198.979C618.603 -178.429 769.864 -136.839 692.911 -5.54986C594.984 161.524 355.681 117.756 461.964 246.709"
        stroke="currentColor"
      />
      <path
        d="M556.595 -200.286C653.074 -179.735 804.335 -138.145 727.383 -6.85637C629.456 160.218 390.153 116.449 496.435 245.402"
        stroke="currentColor"
      />
      <path
        d="M591.078 -200.676C687.557 -180.125 838.818 -138.535 761.866 -7.2459C663.939 159.828 424.636 116.06 530.918 245.013"
        stroke="currentColor"
      />
      <path
        d="M625.559 -199.994C722.038 -179.443 873.299 -137.854 796.346 -6.56475C698.419 160.51 459.116 116.741 565.399 245.694"
        stroke="currentColor"
      />
      <path
        d="M660.015 -198.04C756.494 -177.489 907.755 -135.899 830.802 -4.6104C732.875 162.464 493.572 118.695 599.855 247.648"
        stroke="currentColor"
      />
      <path
        d="M694.409 -194.539C790.888 -173.988 942.149 -132.398 865.196 -1.10943C767.269 165.965 527.966 122.196 634.249 251.149"
        stroke="currentColor"
      />
      <path
        d="M728.677 -189.108C825.156 -168.557 976.417 -126.967 899.465 4.32209C801.537 171.396 562.234 127.628 668.517 256.581"
        stroke="currentColor"
      />
      <path
        d="M762.702 -181.191C859.181 -160.64 1010.44 -119.05 933.489 12.2387C835.562 179.313 596.259 135.544 702.542 264.497"
        stroke="currentColor"
      />
      <path
        d="M796.248 -169.998C892.727 -149.447 1043.99 -107.857 967.035 23.4313C869.108 190.506 629.805 146.737 736.088 275.69"
        stroke="currentColor"
      />
      <path
        d="M828.811 -155.069C925.29 -134.518 1076.55 -92.928 999.598 38.3608C901.671 205.435 662.368 161.666 768.651 290.619"
        stroke="currentColor"
      />
    </svg>
  );
}
